import { handleServerErrors, PrintError } from 'core/infrastructure';
import { SessionProvider } from 'core/infrastructure';
import { OrderingFacade } from 'pos/facades';
import { TicketDTO } from 'core/api';
import { Message } from 'core/ui-next/modal';

type Params = { ticket: TicketDTO, onTicketPrepared: (ticket: TicketDTO) => Promise<void> }

export default async function autoPrepareIfNeeded(params: Params) {

	const session = SessionProvider.getCurrent();
	if (!session.UseAutomaticPreparation)
		return;

	try {


		const ticket = params.ticket;
		if (ticket.IsEmpty)
			return;

		await handleServerErrors(async () => await OrderingFacade.prepareTickets([ticket.Id], true), {
			onPrintError: async (error: PrintError) => { await Message.show(error.message); }
		});

		// Actualizamos el ticket actual porque ha sido preparado
		await params.onTicketPrepared(ticket);
	}
	catch {
		// Como es una autpreparación automática ignoramos el error
	}
}
